import {
  CategoryPicker,
  CategoryPickerProps,
} from '@work4all/components/lib/components/entity-picker/category-picker/CategoryPicker';
import { getCategoryFilter } from '@work4all/components/lib/components/entity-picker/category-picker/use-category-class';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const filter = getCategoryFilter(Entities.supplier);

type SupplierCategoryPickerProps = Omit<CategoryPickerProps, 'filter'>;

export function SupplierCategoryPicker(props: SupplierCategoryPickerProps) {
  return <CategoryPicker {...props} filter={filter} />;
}
